<template>
    <div>
    
    <!-- <p>{{space_info}}</p> -->

    <div v-if="space_info!=null">
      <div class="mediaContainer">
          <div v-if="space_info.media_type=='video'" class="spaceMedia" :frameBorder="0">
              <iframe :src="space_info.url" allowfullscreen="allowfullscreen"> </iframe>
          </div>
          <div v-else class="spaceMedia">
              <img :src="space_info.url"  v-on:click="GalleryIndex = 1">
          </div>
      </div>

    
    <!-- <div><p class="today">today is {{space_info.date}}</p></div> -->
      <div><h2 class="spaceTitle">{{space_info.title}}</h2></div>
      <div><p class="spaceInfo">{{space_info.explanation}}</p></div>



    <div v-if="space_image!=[]">
        <gallery :images="space_image" :index="GalleryIndex" @close="GalleryIndex = null"></gallery>
    </div>


    </div>

    <div v-else><p class="waiting">Wait for it ?</p></div>


</div>

</template>

<script>
import {store} from "../store.js";
import axios from "axios";
import VueGallery from 'vue-gallery';

export default {
    components: { 'gallery': VueGallery },
  data(){
    return{
        space_info:null,
        space_image:[],
        GalleryIndex:null,
        canEnter:true
    }
  },
  methods:{
    // ISS LOCATION API
    getSpace: function(){
      axios.get('https://api.nasa.gov/planetary/apod?api_key=zURMrm9TEUYwLVURLYUJi0mLksFyO6UjPwBhFIyc')
      .then((response)=>{
          this.space_info = response.data;
          this.space_image[0] = response.data.hdurl;
      })
    },

  },
  beforeRouteEnter (to, from, next) {
      if(from.name==null){
        next(vm => {vm.canEnter=false;})
      }
      else{
        next()
      }
  }
  ,created() {
    this.$nextTick(function () {
          if(this.canEnter==false){
            this.$router.push('/404');
          }
          else{
            this.getSpace();
            console.log("You Found it..\nsend me a message saying 'gwent is the best' so i know who you are :)");
          }
    })
    store.clearSubPath();
  },
  watch: {
    $route(to, from) {
      store.clearSubPath();;
    }
  },
}
</script>

<style>
.spaceMedia{
    max-height: 500px;
    max-width: 100%;
    overflow: hidden;
}

.spaceMedia img{
    max-height: 500px;
    max-width: 100%;
}

.mediaContainer{
  margin-top: 1em;;
    text-align: center;
    overflow: hidden;
}

.spaceTitle,.spaceInfo{
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.spaceInfo{
  margin-bottom: 2em;
}

.waiting{
  margin-top: 5em;
  font-family: 'Courier New', Courier, monospace;
  text-align: center;
}

.today{
  font-family: 'Courier New', Courier, monospace;
}

</style>